
// assets
import CurrencyIconPounds from "@/components/icons/Currency/CurrencyIconPounds";
import CurrencyIconAUD from "@/components/icons/Currency/CurrencyIconAUD";
import CurrencyIconEuro from "@/components/icons/Currency/CurrencyIconEuro";
import CurrencyIconUSD from "@/components/icons/Currency/CurrencyIconUSD";
import CurrencyIconSEK from "@/components/icons/Currency/CurrencyIconSEK";
import CurrencyIconPLN from "@/components/icons/Currency/CurrencyIconPLN";
import CurrencyIconCZK from "@/components/icons/Currency/CurrencyIconCZK";


const getCurrencyIcon = (currencyCode: string) => {

  switch (currencyCode) {
    case "AUD":
      return CurrencyIconAUD;
    case "EUR":
      return CurrencyIconEuro;
    case "USD":
      return CurrencyIconUSD;
    case "GBP":
      return CurrencyIconPounds;
    case "SEK":
      return CurrencyIconSEK;
    case "PLN":
      return CurrencyIconPLN;
    case "CZK":
      return CurrencyIconCZK;
    default:
      return CurrencyIconPounds;
  }
};

export default getCurrencyIcon;
